import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const COOKIECONSENTLINKITEMBLOCK_LEGACY_FIELD_ORDER = [
  "label",
  "type"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cookieConsentLinkItemBlockDescriptor: _generatedCookieConsentLinkItemBlockDescriptor,
  cookieConsentLinkItemBlockBlocDefinition,
  cookieConsentLinkItemBlockDashboardLayout,
  cookieConsentLinkItemBlockConfig,
  cookieConsentLinkItemBlockResolveConfig,
  cookieConsentLinkItemBlockProperties,
} = doodBlockConfig(
  {
    name: "Cookie consent link",
    componentType: 'CookieConsentLinkItemBlockComponent',
    category: 'footer',
    description: "Cookie consent link.",
    keywords: [],
    allowedIn: [
      { bloc: "LegalsFooterBlockComponent", slot: "links" },
      { bloc: "BigFooterColumnBlockComponent", slot: "items" },
    ],
    sharedFields: {}
  },

  () => ({
    label: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cookie-consent-link-item.label.label",
      }
    }),
    type: propertyValue({
      type: 'select',
      value: "disclaimer",
      options: {
        label: "pages.blocks.cookie-consent-link-item.type.label",
        help: "pages.blocks.cookie-consent-link-item.type.help",
        choices: [
          {
            value: "disclaimer",
            label: "pages.blocks.cookie-consent-link-item.type.options.disclaimer",
          },
          {
            value: "preferences",
            label: "pages.blocks.cookie-consent-link-item.type.options.preferences",
          }
        ]
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cookie-consent-link-item.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cookie-consent-link-item.fieldset.link.label",
            fields: ["label", "type"],
          },
        ],
      },
    ],
  })
);

export function cookieConsentLinkItemBlockDescriptor(): IBlockDescriptor;
export function cookieConsentLinkItemBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cookieConsentLinkItemBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCookieConsentLinkItemBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCookieConsentLinkItemBlockDescriptor, cookieConsentLinkItemBlockProperties, fieldOrder);
}

export {
  cookieConsentLinkItemBlockBlocDefinition,
  cookieConsentLinkItemBlockDashboardLayout,
  cookieConsentLinkItemBlockProperties,
  cookieConsentLinkItemBlockConfig,
  cookieConsentLinkItemBlockResolveConfig,
};

export type CookieConsentLinkItemBlockConfig = typeof cookieConsentLinkItemBlockConfig;
